// extracted by mini-css-extract-plugin
export default {"root":"NmO7BxromJ8K6jGrWKuZ","anchor":"UaPBSDjsj5aq2CO3Of2A","text":"tmyUqykwjRtd4IqMhcs9","subItemText":"rjNViuRPNkaXjSPN_HBv","subItemLink":"fUUEWP_z3KPp3nIVHVJJ"};